import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { PortalApiService, PropertyListingDetails } from 'src/app/services/portal-api.service';

@Injectable({
  providedIn: 'root'
})
export class SellingDetailsService {

  constructor(private _portalApi: PortalApiService) { }

  data$$ = new BehaviorSubject<PropertyListingDetails | undefined>(undefined);
  data$ = this.data$$.asObservable();

  public getListingDetails(propertyCode: string){
    this._portalApi.getListingDetails(propertyCode ?? '').subscribe(res => {
      this.data$$.next(res)})
  }


}

